import { useFormikContext } from 'formik'
import { isEmpty } from 'lodash'
import React from 'react'

import InteractionFields from 'app/components/InteractionFields'

// Edit an interaction already logged against this parent, from the parent
// dashboard's interactions drawer. The field set itself lives in the shared
// `InteractionFields` component, which the Revenue Goals drawer renders too —
// the two used to carry separate copies and drifted (the drawer had no
// follow-up question at all). This file is now only the EDIT concern: pushing
// the row's stored values into the form.
const EditInteractionForm = (props) => {
  const { formData } = props
  const { setFieldValue } = useFormikContext()

  // MasterForm's <Formik> has no enableReinitialize, so the row's values have
  // to be pushed in once the action data lands (same approach as
  // EditTicketStatusForm).
  React.useEffect(() => {
    if (isEmpty(formData?.interaction_uuid)) return
    setFieldValue('interaction_uuid', formData?.interaction_uuid)
    setFieldValue('interaction_date', formData?.interaction_date || '')
    setFieldValue('connected_status', formData?.connected_status || '')
    setFieldValue('interaction_mode', formData?.interaction_mode || '')
    // Strip each topic row down to what the widget round-trips. The GET
    // serializer also returns a per-row `uuid`, which the replace-all update
    // ignores — dropping it here keeps the payload honest about that.
    setFieldValue(
      'interaction_topics',
      (formData?.interaction_topics || []).map((topic) => ({
        topic: topic?.topic || '',
        summary: topic?.summary || '',
        structured_data: topic?.structured_data || null
      }))
    )
    // null is a real answer here ("no follow-up needed"); '' means unanswered.
    // An existing interaction has always been answered one way or the other.
    setFieldValue(
      'follow_up_date',
      formData?.follow_up_date === undefined ? '' : formData?.follow_up_date
    )
  }, [formData?.interaction_uuid])

  return <InteractionFields defaults={formData} />
}

export default EditInteractionForm
